/** @jsx jsx */
import { jsx } from "@emotion/react"
import Select from 'react-select'
import { formSectionStyles, input, form } from "../assets/styles/FormSection.styles"
import { Col, Container, Row } from "react-bootstrap"
import { useState } from 'react'
import arrow from '../assets/images/LP-versar/bt-arrow.svg'


const HowToWork = () => {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    escola: "",
    estado: "",
    cidade: "",
    funcao: "",
    programa: ""
  })

  const isFormValid = Object.values(formData).slice(0, 7).every(value => value.trim() !== "")
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target
    console.log(e.target)
    console.log('formData', formData)
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const link = document.createElement("a")
    link.href = "/doc/Marketing educacional para instagram - Fractal.pdf"
    link.download = "Marketing educacional para instagram - Fractal.pdf"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    const myForm = document.getElementById('demonstracao-form')
    const formData = new FormData(myForm)

    fetch("/", {
      body: formData,
      method: "POST",
    })
      .then(() => {
        if (typeof window !== "undefined") {
          window.location.href = '/success';
        }
      })
      .catch((error) => {
        console.error(`Erro ao enviar formulário: ${error}`)
      })
  }
  return (
    <section id='contato' css={formSectionStyles}>
      <Container>
        <Row>
          <Col data-aos="fade-left" data-aos-delay="500">
            <Container className="form-container">
              <div id="formulario" className="form-div">
                <h1>Preencha o formulário </h1>
                <p>e comece hoje a <b>transformar a comunicação da sua escola</b></p>
                <form
                  id='demonstracao-form'
                  name='baixe-o-ebook'
                  method='POST'
                  action='/'
                  data-netlify='true'
                  css={form}
                  onSubmit={handleSubmit}
                >
                  <input
                    type='hidden'
                    name='form-name'
                    value='baixe-o-ebook'
                  />
                  <div className='text_input_containe'>
                    <div>
                      <label>Nome*</label>
                      <input
                        className='text_input'
                        type="text"
                        name="nome"
                        // placeholder="Nome"
                        required
                        value={formData.nome}
                        onChange={handleChange}
                      />
                    </div>
                    <div css={input}>
                    <label>Email*</label>
                      <input
                        className='text_input'
                        type="mail"
                        name="email"
                        // placeholder="Email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div css={input}>
                    <label>Telefone*</label>
                      <input
                        className='text_input'
                        type="tel"
                        name="telefone"
                        // placeholder="Telefone"
                        required
                        onChange={handleChange}
                        value={formData.telefone}
                      />
                    </div>
                    <div>
                    <label>Nome da escola (sem abreviações)*</label>
                      <input
                        className='text_input'
                        type="text"
                        name="escola"
                        // placeholder=""
                        required
                        onChange={handleChange}
                        value={formData.escola}
                      />
                    </div>
                  </div>
                  {/* <div className='role-container'>
                    <div className='roles-checkbox'>
                      <span>Cargo:</span>
                      <div className='double_role'>
                        <div className='single-role'>
                          <label class="form-control">
                            <input
                              type="checkbox"
                              name="mantenedor"
                              checked={formData.mantenedor}
                              onChange={handleChange}
                            />
                            Mantenedor(a)
                          </label>
                        </div>
                        <div className='single-role'>
                          <label class="form-control">
                            <input
                              type="checkbox"
                              name="gestor"
                              checked={formData.gestor}
                              onChange={handleChange}
                            />
                            Gestor(a)
                          </label>
                        </div>
                      </div>
                      <div className='double_role'>
                        <div className='single-role'>
                          <label class="form-control">
                            <input
                              type="checkbox"
                              name="coordenador"
                              checked={formData.coordenador}
                              onChange={handleChange}
                            />
                            Coordenador(a)
                          </label>
                        </div>
                        <div className='single-role'>
                          <label class="form-control">
                            <input
                              type="checkbox"
                              name="professor"
                              checked={formData.professor}
                              onChange={handleChange}
                            />
                            Professor(a)
                          </label>
                        </div>
                      </div>
                      <input
                        className='other'
                        type="other_role"
                        name="other_role"
                        placeholder="Outro"
                        value={formData.other_role}
                        onChange={handleChange}
                      />
                    </div>
                  </div> */}
                  <div className='role-container'>
                    <div className='roles-checkbox' style={{ backgroundColor: 'transparent', paddingBottom: 18 }}>
                      <span style={{ width: '100%', textAlign: 'center' }}>Já é parceiro da Fractal?</span>
                      <div className='double_role'>
                        <div className='single-role'>
                          <label class="form-control">
                            <input
                              type="radio"
                              name="programa"
                              value="sim"
                              checked={formData.programa === "sim"}
                              onChange={handleChange}
                            />
                            Sim
                          </label>
                        </div>
                        <div className='single-role'>
                          <label class="form-control">
                            <input
                              type="radio"
                              name="programa"
                              value="nao"
                              checked={formData.programa === "nao"}
                              onChange={handleChange}
                            />
                            Não
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='text_input_containe' style={{ marginBottom: 48 }}>
                    <div>
                    <label>Função na escola*</label>
                    <select required name="funcao" onChange={handleChange}>
                      <option></option>
                      <option value={formData.funcao === "Mantenedor(a)"}>Mantenedor(a)</option>
                      <option value={formData.funcao === "Gestor(a)"}>Gestor(a)</option>
                      <option value={formData.funcao === "Coordenador(a)"}>Coordenador(a)</option>
                      <option value={formData.funcao === "Professor(a)"}>Professor(a)</option>
                    </select>
                    </div>
                    <div>
                    <label>Estado</label>
                      <input
                        className='text_input'
                        type="text"
                        name="estado"
                        // placeholder="Estado"
                        required
                        value={formData.estado}
                        onChange={handleChange}
                      />
                    </div>
                    <div css={input}>
                    <label>Cidade</label>
                      <input
                        className='text_input'
                        type="text"
                        name="cidade"
                        // placeholder="Cidade"
                        required
                        value={formData.cidade}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                    
                  {!isFormValid ? <div className="disabled"></div> : null}
                  <button type='submit' disabled={!isFormValid}>
                    <span>BAIXE O E-BOOK!</span>
                    <img src={arrow} />
                  </button>
                </form>
              </div>
            </Container>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default HowToWork
